module.exports = __webpack_public_path__ + "components/weather-icon/static/dayrainshowers-381ba9e3d2cecd858559c9286a138042.webp";